import React, { useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { useHistory } from 'react-router-dom'
import CenteredLoading from '../components/CenteredLoading'

const AuthCallback = () => {
  const { inProgress } = useMsal()
  const history = useHistory()

  useEffect(() => {
    // In a popup (window.opener set) MSAL processes the response and closes the
    // popup itself — don't navigate. This route is only hit as a full page if a
    // redirect-based flow is used.
    if (window.opener && window.opener !== window) return
    // MSAL finished processing — navigate away regardless of outcome.
    if (inProgress === InteractionStatus.None) {
      history.replace('/')
    }
  }, [inProgress, history])

  // Show spinner while MSAL is exchanging the auth code
  return <CenteredLoading />
}

export default AuthCallback
